"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M6.60854 2.75298L19.2862 9.79343C20.0797 10.2341 20.5 11.097 20.5 12C20.5 12.903 20.0797 13.7659 19.2862 14.2066L6.60854 21.247C5.90338 21.6386 5.14381 21.5535 4.54508 21.1425C3.94191 20.7285 3.5 19.9775 3.5 19.0405V4.95955C3.5 4.0225 3.94191 3.27152 4.54508 2.85747C5.14381 2.44648 5.90338 2.36137 6.60854 2.75298Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M8.2075 3.10261L26.5197 12.9592C28.8268 14.2011 28.8268 17.7989 26.5197 19.0408L8.2075 28.8974C6.23348 29.9599 3.75 28.4613 3.75 25.8566V6.14336C3.75 3.53866 6.23348 2.04009 8.2075 3.10261Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0) }), void 0));
};
var PlayIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.PlayIcon = PlayIcon;
//# sourceMappingURL=PlayIcon.js.map